(function () {
  'use strict';

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('[data-hvo-contact-form]').forEach(function (form) {
    var configNode = form.querySelector('[data-form-config]');
    if (!configNode) return;

    var config = JSON.parse(configNode.textContent);
    var kind = form.dataset.formKind;
    var summary = form.querySelector('[data-error-summary]');
    var summaryTitle = form.querySelector('[data-error-summary-title]');
    var summaryList = form.querySelector('[data-error-summary-list]');
    var fields = {
      naam: form.querySelector('[name="contact[name]"]'),
      email: form.querySelector('[name="contact[email]"]'),
      telefoon: form.querySelector('[name="contact[phone]"]'),
      bericht: form.querySelector(kind === 'quote' ? '[name="contact[message]"]' : '[name="contact[body]"]'),
    };
    var required = kind === 'quote' ? ['naam', 'email'] : ['naam', 'email', 'bericht'];

    function errorNode(key) {
      return form.querySelector('[data-field-error="' + key + '"]');
    }

    function clearFieldError(key) {
      var field = fields[key];
      var node = errorNode(key);
      if (node) {
        node.hidden = true;
        node.textContent = '';
      }
      if (!field) return;
      field.removeAttribute('aria-invalid');
      if (!node || !node.id) return;
      var describedBy = (field.getAttribute('aria-describedby') || '')
        .split(/\s+/)
        .filter(function (id) {
          return id && id !== node.id;
        });
      if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
      else field.removeAttribute('aria-describedby');
    }

    function clearErrors() {
      Object.keys(fields).forEach(clearFieldError);
      if (summary) summary.hidden = true;
      if (summaryList) summaryList.textContent = '';
    }

    function reject(key, message) {
      var field = fields[key];
      if (!field) return null;
      var node = errorNode(key);
      if (node) {
        node.id = field.id + '-client-error';
        node.textContent = message;
        node.hidden = false;
        var describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (!describedBy.includes(node.id)) describedBy.push(node.id);
        field.setAttribute('aria-describedby', describedBy.join(' '));
      }
      field.setAttribute('aria-invalid', 'true');
      return { field: field, message: message };
    }

    function renderSummary(errors) {
      if (!summary || !summaryTitle || !summaryList) return;
      summaryTitle.textContent = errors.length === 1
        ? config.summaryOne
        : config.summaryMany.replace('__count__', String(errors.length));
      errors.forEach(function (error) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + error.field.id;
        link.textContent = error.message;
        item.appendChild(link);
        summaryList.appendChild(item);
      });
      summary.hidden = false;
      summary.focus();
    }

    var contextValues = [];
    var context = form.querySelector('[data-quote-context]');
    var contextLines = form.querySelector('[data-quote-context-lines]');
    var quoteBody = form.querySelector('[data-quote-body]');

    function loadQuoteContext() {
      if (kind !== 'quote') return;
      var allowed = (form.dataset.quoteContextParams || '').split(',').map(function (key) {
        return key.trim();
      }).filter(Boolean);
      var params = new URLSearchParams(window.location.search);
      allowed.forEach(function (key) {
        params.getAll(key).forEach(function (value) {
          var trimmed = value.trim();
          if (trimmed) contextValues.push(trimmed);
        });
      });
      if (!contextValues.length || !context || !contextLines) return;
      contextValues.forEach(function (value) {
        var line = document.createElement('span');
        line.textContent = value;
        contextLines.appendChild(line);
      });
      context.hidden = false;
    }

    function writeQuoteBody() {
      if (kind !== 'quote' || !quoteBody) return;
      var message = fields.bericht ? fields.bericht.value.trim() : '';
      quoteBody.value = contextValues.concat(message ? [message] : []).join('\n');
    }

    form.addEventListener('submit', function (event) {
      clearErrors();
      var errors = [];

      Object.keys(fields).forEach(function (key) {
        if (fields[key]) fields[key].value = fields[key].value.trim();
      });

      required.forEach(function (key) {
        if (!fields[key] || fields[key].value !== '') return;
        var found = reject(key, config.required[key]);
        if (found) errors.push(found);
      });

      if (fields.email && fields.email.value !== '' && !emailPattern.test(fields.email.value)) {
        if (!errors.some(function (error) { return error.field === fields.email; })) {
          var emailError = reject('email', config.email);
          if (emailError) errors.push(emailError);
        }
      }

      if (errors.length) {
        event.preventDefault();
        renderSummary(errors);
        return;
      }

      writeQuoteBody();
    });

    loadQuoteContext();
    writeQuoteBody();
  });
})();
